import { render, staticRenderFns } from "./editNota.vue?vue&type=template&id=843b7778"
import script from "./editNota.vue?vue&type=script&lang=js"
export * from "./editNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports